export default () => ({
  active: false,
  title: "",
  text: "",
  camera: "",
  confirmation: false,
  confirmationFn() {},
  onClose() {},
  actions: [],
});
